import "../../media/_global.scss";
import "./MainPage.scss";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import WhatToDo from "../../components/WhatToDo/WhatToDo";
import Book from "../../components/Book/Book";
import AuthContext from "../../context/AuthContext";
import book from '../../media/misc/book.png';
import community from '../../media/misc/community.png';
import pen from '../../media/misc/pen.png';
import { API_BASE_URL } from '../../config';

const BENEFITS = [
    {
        title: 'انشر مجانًا، بلا ناشر',
        text: 'لا حاجة لدور نشر ولا لعقود. انشر كتابك بنفسك وفي ثوانٍ، وللأبد، بدون أي رسوم.',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 14.94V18h-2v-1.07a4 4 0 0 1-3-3.83h2a2 2 0 0 0 2 2 2 2 0 0 0 .54-3.92l-1.62-.46a4 4 0 0 1 .08-7.7V2h2v1.06a4 4 0 0 1 3 3.84h-2a2 2 0 0 0-2-2 2 2 0 0 0-.54 3.92l1.62.46A4 4 0 0 1 13 16.94Z"/>
            </svg>
        ),
    },
    {
        title: 'حرية كاملة في الموضوع',
        text: 'اكتب عمّا تشاء، بلا رقابة من ناشر ولا تعديلات مفروضة. كلماتك تصل إلى القراء كما كتبتها أنت.',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 2 4 5v6c0 5 3.4 9.6 8 11 4.6-1.4 8-6 8-11V5l-8-3Zm0 2.15 6 2.25V11c0 4.05-2.7 7.78-6 9-3.3-1.22-6-4.95-6-9V6.4l6-2.25ZM10.5 16.5 7 13l1.4-1.4 2.1 2.08L15.6 8.6 17 10l-6.5 6.5Z"/>
            </svg>
        ),
    },
    {
        title: 'صوت عربي حر',
        text: 'منصة عربية للكتاب العرب، تحترم لغتك وثقافتك ومجتمعك، مكتوبة من الصفر بالعربية.',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm6.93 9h-2.95a15.7 15.7 0 0 0-1.38-5.84A8 8 0 0 1 18.93 11Zm-6.93 8.93c-.83 0-1.94-2.1-2.5-5.93h5c-.56 3.83-1.67 5.93-2.5 5.93ZM9.5 12a23 23 0 0 1 0-1h5a23 23 0 0 1 0 1 23 23 0 0 1 0 1h-5a23 23 0 0 1 0-1Zm.5-3.07c.56-3.83 1.67-5.93 2.5-5.93s1.94 2.1 2.5 5.93Zm-.6-2.77A15.7 15.7 0 0 0 8.02 12H5.07a8 8 0 0 1 4.33-5.84ZM5.07 13h2.95a15.7 15.7 0 0 0 1.38 5.84A8 8 0 0 1 5.07 13Zm9.53 5.84A15.7 15.7 0 0 0 15.98 13h2.95a8 8 0 0 1-4.33 5.84Z"/>
            </svg>
        ),
    },
];

export default function MainPage() {

    const { user } = useContext(AuthContext);
    const [featured, setFeatured] = useState([]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/books/library/`);
                if (!r.ok) return;
                const data = await r.json();
                if (!cancelled) setFeatured((data.books ?? []).slice(0, 6));
            } catch { /* silently skip — homepage shouldn't error */ }
        })();
        return () => { cancelled = true; };
    }, []);

    return (
        <>
        <Navbar />

        <div className="info-container">
            <h1 className="info-title">أهلًا بك في راوية</h1>
            <p className="info-subtitle">موقع لكتابة ونشر القصص والروايات العربية</p>
        </div>

        <div className="wtd-container">
            <WhatToDo
                icon={pen}
                title={"أنشر قصصك ورواياتك"}
                content={"شاركنا أحدث رواياتك وانشرها بين القراء"}
                buttonContent={"ابدأ الكتابة"}
                to={user ? "myworks" : "register"}
            />
            <WhatToDo
                icon={community}
                title={"تعرّف على القراء والكتّاب"}
                content={"ابدأ نقاشًا جديدًا أو شارك في مواضيع المجتمع"}
                buttonContent={"ادخل النقاشات"}
                to={"discussions"}
            />
            <WhatToDo
                icon={book}
                title={"اقرأ أحدث الروايات"}
                content={"مجموعة من أحدث ما خطّته أقلام كتّاب موقع راوية"}
                buttonContent={"ابدأ القراءة"}
                to={"library"}
            />
        </div>

        <section className="section section--benefits">
            <div className="section-header">
                <h2 className="section-title">لماذا راوية؟</h2>
                <p className="section-subtitle">منصة عربية للكتّاب، مجانية ومفتوحة، وبدون وسطاء</p>
            </div>
            <div className="benefits-grid">
                {BENEFITS.map((b, i) => (
                    <div key={i} className="benefit">
                        <div className="benefit-icon">{b.icon}</div>
                        <h3 className="benefit-title">{b.title}</h3>
                        <p className="benefit-text">{b.text}</p>
                    </div>
                ))}
            </div>
        </section>

        <section className="section">
            <div className="section-header">
                <h2 className="section-title">من المكتبة</h2>
                <p className="section-subtitle">أحدث الكتب المنشورة من قبل كتّاب راوية</p>
            </div>

            {featured.length === 0 ? (
                <div className="featured-empty">
                    لا توجد كتب منشورة بعد. كن أوّل من ينشر!
                </div>
            ) : (
                <>
                    <div className="featured-grid">
                        {featured.map(b => (
                            <Book
                                key={b.id}
                                id={b.id}
                                title={b.title}
                                author={b.author}
                                displayAuthor={b.display_author}
                                coverImage={b.cover_image}
                                categoryLabel={b.category_label}
                                is_published={b.is_published}
                                showBadge={false}
                                to={`/read/${b.id}`}
                            />
                        ))}
                    </div>
                    <div className="featured-cta">
                        <Link to="/library" className="featured-cta-link">تصفّح المكتبة كاملة</Link>
                    </div>
                </>
            )}
        </section>

        <Footer />
        </>
    );
}
